<div class="animate__animated animate__fadeInRight">
    <br />

    <div class="col">
        <mat-card class="mat_card_general">

            <h1 class="p-3">Modulo de Implementos</h1>
        </mat-card>
    </div>

    <br />
   <mat-card class="mat-elevation-z0 mat_card_general_content">

    <app-lista-implementos></app-lista-implementos>


    </mat-card>
    <hr />
</div>
